// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1rjcpxbi{padding-block:var(--ds-space-200,1pc)}._12ornqa1{border-block-end-style:solid}\n._1ezzmuej{border-block-end-color:var(--ds-border,#091e4224)}\n._1r62e4h9{border-block-end-width:var(--ds-border-width,1px)}\n._n3tdpxbi{padding-bottom:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
